export enum SupportedLanguages {
  en = 'en',
  fr = 'fr',
  pt = 'pt',
  es = 'es',
}
